import { render, staticRenderFns } from "./clock-group.vue?vue&type=template&id=79576df9&scoped=true&"
import script from "./clock-group.vue?vue&type=script&lang=js&"
export * from "./clock-group.vue?vue&type=script&lang=js&"
import style0 from "./clock-group.vue?vue&type=style&index=0&id=79576df9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79576df9",
  null
  
)

export default component.exports